/**
 * Erweitert den $alert-Dienst um die Möglichkeit, Audios abzuspielen. Das Alert-Fenster verschwindet nicht, solange noch
 * Audio abgespielt wird oder der Mauszeiger drüber steht.
 *
 * @class service_v3sAlertService
 * @memberOf v3sWbtPlayerApp:page
 */
angular.module('v3sWbtPlayerApp').factory('v3sAlertService', ["$alert", "$animate", "$timeout", "$compile", "$rootScope", "v3sMediaService", "v3sStringService", function ($alert, $animate, $timeout, $compile, $rootScope, v3sMediaService, v3sStringService) {
    var defaults = {
        show: true
    };

    function AlertFactory(config) {
        var v3sAlert = {};

        // Standardwerte übernehmen
        var options = angular.extend({ }, defaults, config);

        // Dauer-Option auslesen und entfernen
        var duration = options.duration;
        options.duration = null;

        var timer = null;
        var audio = null;

        // Alert-Fenster anzeigen
        v3sAlert = $alert(options);

        // Warten auf Audio und / oder vorgegebene Dauer
        var waitCount = !!options.audio + 1;

        var isTouch = false;
        var isHover = false;
        var isHiding = false;
        var currentAnimation = null;

        var show = v3sAlert.show;
        v3sAlert.show = function () {
            // Fenster anzeigen
            show();

            var alertElement = v3sAlert.$element;

            var data = alertElement.find("v3s-data");
            if (options.scope) {
                $compile(data)(options.scope);
            } else {
                $compile(data)($rootScope);
            }

            // Ggf. Anzeigedauer aus Textlänge berechnen
            if (!duration) {
                duration = v3sStringService.textLength(alertElement) / 10 + 8;
            }

            // Timer für die vorgegebene Dauer starten
            timer = startHideTimer(duration);

            // Auf Maus- und Touch-Events horchen
            alertElement.on('mouseenter', function () {
                reactivateWindow();
                isHover = !isTouch;
            });

            alertElement.on('touchstart', function () {
                reactivateWindow();
                isHover = false;
                isTouch = true;
            });

            alertElement.on('mouseleave', function () {
                isHover = false;

                // Fenster schließen, wenn nicht mehr auf Audio oder Dauer gewartet wird
                if (waitCount < 1) {
                    v3sAlert.hideSlowly();
                }
            });

            // Audio abspielen und auf Audio-Events horchen
            v3sMediaService.getMedia(options.audio).then(function (_audio) {
                audio = _audio;
                audio.onEnded(function () {
                    if (tryHide()) {
                        $timeout.cancel(timer);
                    }
                });

                audio.onError(function () {
                    tryHide();
                });

                audio.play();
            });
        };

        var hide = v3sAlert.hide;
        v3sAlert.hide = function () {
            if (currentAnimation) {
                currentAnimation.cancel();
                currentAnimation = null;
            }

            $timeout.cancel(timer);
            if (!!audio) audio.stop();

            hide();
        }

        v3sAlert.hideSlowly = function () {
            isHiding = true;

            // Animation funktioniert nur nach Timeout zuverlässig
            $timeout(function () {
                currentAnimation = $animate.addClass(v3sAlert.$element, "v3s-alert-animation");
                currentAnimation.then(v3sAlert.hide);
            });
        }

        function tryHide() {
            if (waitCount == 1 && !isHover) {
                v3sAlert.hideSlowly();
                return true;
            } else {
                waitCount--;
                return false;
            }
        }

        function startHideTimer(timeout) {
            if (timeout < 0) {
                return null;
            }

            return $timeout(tryHide, timeout * 1000);
        }

        function reactivateWindow() {
            if (isHiding) {
                isHiding = false;

                if (currentAnimation) {
                    currentAnimation.cancel();
                    currentAnimation = null;
                }
                $animate.removeClass(v3sAlert.$element, "v3s-alert-animation");

                waitCount = 1;

                $timeout.cancel(timer);
                timer = startHideTimer(duration ? duration / 2 : 5);
            }
        }

        return v3sAlert;
    }

    return AlertFactory;
}]);